import React from "react";
import { ReactComponent as GoogleSvg } from "assets/images/heylime-layout/signup/google-icon.svg";
import { ReactComponent as AppleSvg } from "assets/images/heylime-layout/signup/apple-icon.svg";
import { ReactComponent as MicrosoftSvg } from "assets/images/heylime-layout/signup/microsoft-icon.svg";
import { ReactComponent as AmazonSvg } from "assets/images/heylime-layout/signup/amazon-icon.svg";
import { ReactComponent as FacebookSvg } from "assets/images/heylime-layout/signup/facebook-icon.svg";
import { ReactComponent as EmailSvg } from "assets/images/heylime-layout/signup/email-icon.svg";

const SocialSignIn = ({ onSignIn }) => {
  const SocialElement = ({ icon: Icon, text, provider }) => (
    <div className="social-item" onClick={() => onSignIn(provider)}>
      <Icon className="social-icon" />
      <span className="content-text">{text}</span>
    </div>
  );
  return (
    <div className="social-container">
      <div className="social-list">
        <SocialElement icon={GoogleSvg} text="Google" provider="Google" />
        <SocialElement
          icon={AppleSvg}
          text="Apple"
          provider="SignInWithApple"
        />
        <SocialElement
          icon={MicrosoftSvg}
          text="Microsoft"
          provider="Microsoft"
        />
        <SocialElement
          icon={AmazonSvg}
          text="Amazon"
          provider="LoginWithAmazon"
        />
        <SocialElement icon={FacebookSvg} text="Facebook" provider="Facebook" />
        <SocialElement icon={EmailSvg} text="Use Email" provider="Email" />
      </div>
    </div>
  );
};

export default SocialSignIn;
